export default {"src":"/_next/static/media/trader-joe-lend.de98e867.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};